module.exports = __webpack_public_path__ + "img/merchantRevenue.37a70c0c.svg";